import { Injectable } from '@angular/core';
import { Broker } from '@c4/core';

@Injectable()
export class DateTimeService {

  constructor(private broker: Broker) {}

  // returns ISO8601 date that you can pass into new Date(x)
  public getDateTime = (ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

      let request: any = {
        method: 'GET',
        path: '/api/v1/sysman/date' + (ip ? "?ip=" + ip : "")
      };
      this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  // get enable/disable status of processes
  public getNTPConfig = (ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

    let request: any = {
      method: 'GET',
      path: '/api/v1/sysman/ntp/config' + (ip ? "?ip=" + ip : "")
    };
      this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  public setNTPConfig = (ntp: string, otherTimeServer: string, ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

    let putData: any = {};
    if (ip)
      putData['ip'] = ip;

    // method = one of "server", "local", or other <addr>"
    if (ntp == "") {
      putData['method'] = "client";
      putData['address'] = otherTimeServer;
    }
    else {
      putData['method'] = ntp;
    }

    var request: any = {
      method: 'PUT',
      path: '/api/v1/sysman/ntp/config',
      data: putData
    };
    this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/datetime.service.ts